import React from 'react';
import { ThunderboltFilled } from '@ant-design/icons';
import { Tooltip } from 'antd';

const ImmediateFollowUpBadge = ({ muted = false, className = '' }) => (
  <Tooltip title="این فعالیت به‌صورت فوری ثبت شده است">
    <span
      className={[
        'inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-semibold shadow-sm',
        muted
          ? 'bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-900/20 dark:text-amber-300 dark:border-amber-800'
          : 'bg-gradient-to-r from-amber-500 via-orange-500 to-rose-500 text-white ring-1 ring-orange-200/60 dark:ring-orange-800/40',
        className,
      ].join(' ')}
      style={{ fontFamily: 'CustomFont' }}
    >
      <ThunderboltFilled style={{ fontSize: 11 }} />
      پیگیری فوری
    </span>
  </Tooltip>
);

export default ImmediateFollowUpBadge;
